type LiveblogApiRequest = {
    blogId: string;
    postCount?: number;
    signal?: AbortSignal;
};

export async function fetchLiveblogFromApi({
    blogId,
    postCount,
    signal,
}: LiveblogApiRequest) {
    const liveblogResponse = await fetch(
        `/lineup-next/api/liveblog/${blogId}${
            postCount ? `?postCount=${postCount}` : ""
        }`,
        { signal }
    );

    if (!liveblogResponse.ok) {
        throw new Error(
            `Error when fetching from api/liveblog: ${await liveblogResponse.text()}`
        );
    }

    return liveblogResponse.json();
}
